import { ChevronDownIcon, ChevronUpIcon } from "@commonlibs";
import { spacingProxy as spacing } from "./spacing/spacingProxy";
import typography from "./typography/typography";

const baseTheme = {
    typography,
    borderRadius: spacing[2],
    borderRadiusLg: spacing[4],
    borderRounded: "99999px",
    spacing,
    icons: {
        chevronDown: ChevronDownIcon,
        chevronUp: ChevronUpIcon,
    },
};

export default baseTheme;
